import { render, staticRenderFns } from "./FormRsvpBlockGeneralSettings.vue?vue&type=template&id=5423497a"
import script from "./FormRsvpBlockGeneralSettings.vue?vue&type=script&lang=js"
export * from "./FormRsvpBlockGeneralSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports